import { ReactNode, useState } from "react";

import Box from "ds/components/Box";
import PaginationIndicator from "components/PaginationIndicator";
import PageInfoHeader from "ds/components/PageInfoHeader";
import FiltersContentWrapper from "components/Filters/ContentWrapper";
import Filters from "components/Filters";
import FiltersSplit from "components/Filters/Split";
import FiltersSidebar from "components/Filters/Sidebar";
import {
  FilterItem,
  FiltersItemsOptionsMap,
  SavedFilterView,
  SortOption,
} from "components/Filters/types";
import { AnalyticsPagePolicy } from "hooks/useAnalytics/pages/policy";

import PolicyDetailsSamplesListLayoutHeader from "./Header";
import {
  FILTERS_ORDER_SETTINGS_KEY,
  FILTERS_TYPE,
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  FILTER_ITEMS_DICTIONARY,
} from "../constants";

type PolicyDetailsSamplesListLayoutProps = {
  children: ReactNode;
  renderedEntitiesCount: number;
  isPageEmpty: boolean;
  loadingIndication: boolean;
  filteredCount: number;
  filters: FilterItem[];
  filtersMap: FiltersItemsOptionsMap;
  sortOptions: SortOption[];
  filtersLoading: boolean;
  refetchActiveSections: (fields: string[]) => void;
};

const PolicyDetailsSamplesListLayout = ({
  filters,
  filtersMap,
  sortOptions,
  filtersLoading,
  refetchActiveSections,
  children,
  renderedEntitiesCount,
  isPageEmpty,
  loadingIndication,
  filteredCount,
}: PolicyDetailsSamplesListLayoutProps) => {
  const [currentSavedView, setCurrentSavedView] = useState<SavedFilterView | undefined>(undefined);

  return (
    <>
      <PageInfoHeader title="Samples">
        <Box direction="row" align="center" gap="0 large">
          {!isPageEmpty && (
            <>
              <PaginationIndicator
                currentCount={renderedEntitiesCount}
                totalCount={filteredCount}
                loading={loadingIndication}
                minimumLoadingDuration={200}
              />
            </>
          )}
        </Box>
      </PageInfoHeader>

      <Filters
        filters={filters}
        filtersItemsOptionsMap={filtersMap}
        filtersLoading={filtersLoading}
        sortOptions={sortOptions}
        initialSortOption={INITIAL_SORT_OPTION}
        initialSortDirection={INITIAL_SORT_DIRECTION}
        pollActiveSections={refetchActiveSections}
        filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
        filtersDictionary={FILTER_ITEMS_DICTIONARY}
        filtersType={FILTERS_TYPE}
        currentSavedView={currentSavedView}
        setCurrentSavedView={setCurrentSavedView}
      >
        <FiltersSplit>
          <FiltersSidebar analyticsPage={AnalyticsPagePolicy.PoliciesList} />

          <FiltersContentWrapper>
            {!isPageEmpty && <PolicyDetailsSamplesListLayoutHeader />}

            {children}
          </FiltersContentWrapper>
        </FiltersSplit>
      </Filters>
    </>
  );
};

export default PolicyDetailsSamplesListLayout;
